var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Caja","loading":_vm.isLoading,"items":_vm.cashAccounts,"item-text":"name","item-value":"id","required":""},model:{value:(_vm.selectedCashAccount),callback:function ($$v) {_vm.selectedCashAccount=$$v},expression:"selectedCashAccount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }